import { render, staticRenderFns } from "./LecturePage.vue?vue&type=template&id=2fe43466&"
import script from "./LecturePage.vue?vue&type=script&lang=js&"
export * from "./LecturePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports